export default "__VITE_ASSET__Ccs76s4A__"